import { config } from "./config";

export const init = () => {
  const { env } = config;

  if (env === 'production') {
    return;
  }
};
